import React from "react";
import { useNavigate } from "react-router-dom";
import "./ServiceSelection.css";
import ScreenHeader from "./ReuseComponent/ScreenHeader";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

const CareServiceCard = ({ service, setSelectedSection }) => {
  const navigate = useNavigate();
  const imgList = {
    "Personal Care Service": 1,
    "Companionship and Outings": 2,
    "House Hold Support": 3,
    "Support for Daily Living": 4,
    "Technology Support": 5,
  };

  return (
    <div
      onClick={() => {
        navigate(`/CareServiceProfile?id=${service.care_service_id}`, {
          state: {
            data: service,
            imgIndex: imgList[service.care_service_name] || 1,
          },
        });
      }}
      className="SS-card"
    >
      <div className="SS-card-img-wrapper">
        <img
          src={require(
            `../images/care_service_${
              imgList[service.care_service_name] || 1
            }.png`,
          )}
          alt={service.care_service_name}
          className="SS-card-img"
        />
      </div>
      <div className="SS-card-content">
        <h2 className="SS-card-title">{service.care_service_name}</h2>
        <p className="SS-card-desc">{service.description}</p>
      </div>
    </div>
  );
};

const ServiceSelection = ({ setSelectedSection, services }) => {
  return (
    <div className="SS-container screen-container">
      <ScreenHeader
        icon={faHeart}
        title="Care Services"
        subtitle="Personalized, non-medical home care delivered by trusted iCare Village caregivers – right where you live"
      />

      <div className="SS-grid">
        {!services || services.length === 0 ? (
          <div style={{ display: "flex", justifyContent: "center", width: "100%", gridColumn: "1 / -1", padding: "50px 0" }}>
            <img
              src={require("../images/loading_icon.gif")}
              alt="Loading services"
              style={{ width: "50px" }}
            />
          </div>
        ) : (
          services.map((service, index) => (
            <CareServiceCard
              key={index}
              service={service}
              setSelectedSection={setSelectedSection}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ServiceSelection;
